import React from 'react';
import { Box } from '../../core';

export const ImxStrategy = (): JSX.Element | null => {
  return <Box>imx strategy</Box>;
};
